import React from 'react';
import Reveal from '../Reveal/Reveal';
import '../../styles/fullvideo.css';

/* Full-width farm video band. File lives in public/duck.mp4 */
const SRC = `${process.env.PUBLIC_URL}/duck.mp4`;
const SPEED = 0.6; // slow-motion playback

export default function FullVideo() {
  const setSpeed = (e) => {
    e.currentTarget.playbackRate = SPEED;
  };

  return (
    <Reveal as="section" className="full-video reveal-zoom" aria-label="Farm video">
      <video
        className="full-video__player"
        src={SRC}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        onLoadedMetadata={setSpeed}
      />
      <div className="full-video__grade" aria-hidden="true" />
      <div className="full-video__overlay" aria-hidden="true" />

      <div className="container full-video__content">
        <div className="full-video__inner">
          <h2 className="full-video__title">
            Farming <em>hand in hand</em> with nature
          </h2>
          <p className="full-video__text">
            Ducks roam freely through our paddies — nature's own helpers,
            keeping pests and weeds away, so our rice grows pure and chemical-free.
          </p>
        </div>
      </div>
    </Reveal>
  );
}
